export enum Step {
  PERSONALIZE = 'personalize',
  PREVIEW = 'preview',
}

export enum ToolbarType {
  COLOR = 'color',
  FONT = 'font',
  TEXT = 'text',
}

export interface CanvasDimensions {
  canvasHeight: number;
  canvasWidth: number;
  canvasX: number;
  canvasY: number;
  scale: number;
  scaleX: number;
  scaleY: number;
  valid: boolean;
}

interface UIState {
  activeObjectId: string | undefined;
  canvasDimensions: CanvasDimensions;
  hasActiveObject: boolean;
  lastActiveObjectId: string | undefined;
  step: Step;
  toolbar: ToolbarType | undefined;
}

const initialUIState: UIState = {
  activeObjectId: undefined,
  canvasDimensions: {
    canvasHeight: 0,
    canvasWidth: 0,
    canvasX: 0,
    canvasY: 0,
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    valid: false,
  },
  hasActiveObject: false,
  lastActiveObjectId: undefined,
  step: Step.PERSONALIZE,
  toolbar: undefined,
};

export type { UIState };
export default initialUIState;
